import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Portfolio from "@/components/Portfolio";
import ArtProjects from "@/components/ArtProjects";
import DesignWork from "@/components/DesignWork";
import About from "@/components/About";
import Skills from "@/components/Skills";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import ArtProjectDetail from "@/pages/ArtProjectDetail";
import Fashion from "@/pages/Fashion";
import { Toaster } from "@/components/ui/sonner";

const Home = () => {
  return (
    <div className="min-h-screen bg-zinc-950">
      <Header />
      <Hero />
      <Portfolio />
      <ArtProjects />
      <DesignWork />
      <About />
      <Skills />
      <Contact />
      <Footer />
      <Toaster />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/fashion" element={<Fashion />} />
          <Route path="/project/:slug" element={<ArtProjectDetail />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
